<template>
    <!-- 推广中心 -->
    <ZhaiHead />

    <div class="container-fluid px-0 zhu">
        <!-- 顶部核心数据模块 -->
        <div class="promo-top">
            <div class="promo-title">
                <i class="fa fa-bullhorn"></i>推广中心
            </div>

            <div class="promo-main">
                <div class="promo-money">{{ todayIncome }}</div>
                <div class="promo-text">今日收入（元）</div>
            </div>

            <div class="promo-stat">
                <div class="stat-item">
                    <div class="stat-money">¥{{ yesterdayIncome }}</div>
                    <div class="stat-label">昨日收入</div>
                </div>
                <div class="stat-line"></div>
                <div class="stat-item">
                    <div class="stat-money">{{ myCustomers }}</div>
                    <div class="stat-label">我的客户</div>
                </div>
                <div class="stat-line"></div>
                <div class="stat-item">
                    <div class="stat-money">¥{{ totalIncome }}</div>
                    <div class="stat-label">累计收入</div>
                </div>
            </div>
        </div>

        <!-- 内容区 -->
        <div class="content-area py-3">
            <!-- ✅ 我的客户（带图标） -->
            <div class="card-item row-item clickable no-gap-after" @click="goMyCustomers">
                <div class="row-left">
          <span class="row-ico">
            <i class="fa fa-user"></i>
          </span>
                    <span class="row-text">我的客户</span>
                </div>
                <span class="arrow">›</span>
            </div>

            <!-- ✅ 我的推广海报（带图标） -->
            <div class="card-item row-item clickable" @click="goPromotionPoster">
                <div class="row-left">
          <span class="row-ico">
            <i class="fa fa-picture-o"></i>
          </span>
                    <span class="row-text">我的推广海报</span>
                </div>
                <span class="arrow">›</span>
            </div>

            <!-- 推广链接（✅ 点击复制 + 成功模态框） -->
            <div class="card-item">
                <div class="fw-bold mb-2">推广链接</div>

                <!-- ✅ 可点击复制 -->
                <div class="link-box clickable-text" role="button" @click="copyPromoLinkAndModal">
                    {{ promoLink }}
                </div>

                <div class="promo-link-tip">点击链接可复制</div>
            </div>

            <!-- ✅ 微信 / QQ 推广专用 -->
            <div class="card-item wxqq-card">
                <div class="wxqq-header">
                    <span class="wxqq-title">微信 / QQ 推广专用</span>

                    <!-- ✅ 按钮：未生成/过期=生成；已生成=复制（弹模态框） -->
                    <button class="wxqq-btn" :disabled="genLoading" @click="onWxqqBtnClick">
                        {{ wxqqBtnText }}
                    </button>
                </div>

                <!-- ✅ 未生成：保持你要求的“生成前样式”（只显示文案，不显示链接行） -->
                <div class="wxqq-body" v-if="!antiBlockLink">
                    <div class="wxqq-desc">
                        【{{ shareText }}】
                    </div>
                </div>

                <!-- ✅ 已生成：保持你要求的“生成后样式” -->
                <div class="wxqq-body" v-else>
                    <!-- ✅ 点击链接复制 + 模态框 -->
                    <div class="wxqq-link clickable-text" role="button" @click="copyAntiBlockAndModal">
                        {{ antiBlockLink }}
                    </div>

                    <!-- ✅ 点击文案复制 + 模态框 -->
                    <div class="wxqq-desc clickable-text" role="button" @click="copyAntiBlockAndModal">
                        【{{ shareText }}】
                    </div>

                    <div class="wxqq-expire" v-if="antiBlockExpiredAt">
                        <span v-if="!isAntiBlockExpired">有效期：{{ expireCountdownText }}</span>
                        <span v-else>链接已过期，请重新生成</span>
                    </div>

                    <div class="wxqq-tip">点击链接/文案可复制【链接+文案】</div>
                </div>
            </div>

            <!-- ✅ 推广明细（带图标 + 点击跳转） -->
            <div class="card-item row-item clickable no-gap-after" @click="goPromotionDetails">
                <div class="row-left">
          <span class="row-ico">
            <i class="fa fa-book"></i>
          </span>
                    <span class="row-text">推广明细</span>
                </div>
                <span class="arrow">›</span>
            </div>

            <!-- ✅ 申请提现（带图标 + 点击弹窗） -->
            <div class="card-item row-item clickable" @click="openWithdrawModal">
                <div class="row-left">
          <span class="row-ico">
            <i class="fa fa-credit-card"></i>
          </span>
                    <span class="row-text">申请提现</span>
                </div>
                <span class="arrow">›</span>
            </div>

            <!-- ✅ 推广规则（带图标 + 必读 + 箭头） -->
            <div class="card-item row-item clickable" @click="goPromotionRules">
                <div class="row-left">
          <span class="row-ico">
            <i class="fa fa-th-large"></i>
          </span>
                    <span class="row-text">推广规则</span>
                </div>

                <div class="row-right">
                    <span class="must">必读</span>
                    <span class="arrow">›</span>
                </div>
            </div>
        </div>
    </div>

    <!-- ✅ 申请提现模态框（保持你原逻辑） -->
    <div v-if="withdrawModal.visible" class="modal-mask" @click.self="closeWithdrawModal">
        <div class="modal-card" role="dialog" aria-modal="true">
            <div class="modal-title">申请提现</div>
            <div class="modal-desc">即将跳转到【钱包中心】进行提现</div>

            <div class="modal-actions">
                <button class="modal-btn cancel" @click="closeWithdrawModal" :disabled="withdrawModal.loading">
                    取消
                </button>
                <button class="modal-btn ok" @click="confirmWithdraw" :disabled="withdrawModal.loading">
                    {{ withdrawModal.loading ? "处理中..." : "确定" }}
                </button>
            </div>
        </div>
    </div>

    <!-- ✅ 复制成功模态框（推广链接/防屏蔽链接/文案/按钮复制都会弹） -->
    <div v-if="copyModal.visible" class="modal-mask" @click.self="closeCopyModal">
        <div class="modal-card" role="dialog" aria-modal="true">
            <div class="modal-title">提示</div>
            <div class="modal-desc">{{ copyModal.text }}</div>

            <div class="modal-actions">
                <button class="modal-btn ok" @click="closeCopyModal">确定</button>
            </div>
        </div>
    </div>

    <ZhaiFoot />
</template>

<script>
    import ZhaiHead from "../components/ZhaiHead";
    import ZhaiFoot from "../components/ZhaiFoot";
    import http from "../utils/http.js";

    export default {
        name: "MPromotion",
        components: { ZhaiHead, ZhaiFoot },

        // 路由守卫：未登录直接跳登录页（对齐 PC）
        beforeRouteEnter(to, from, next) {
            const token = localStorage.getItem("token");
            if (!token) next("/login");
            else next();
        },

        data() {
            return {
                // ================== 数据概览 ==================
                todayIncome: "0.00",
                yesterdayIncome: "0.00",
                myCustomers: 0,
                totalIncome: "0.00",

                // ================== 推广/防屏蔽 ==================
                promoLink: "",
                antiBlockLink: "", // 页面展示：必须用户点按钮才赋值
                genLoading: false,

                // 业务短链缓存：给海报/业务用，不影响页面“必须手动生成才回显”的规则
                antiBlockLinkCache: "",

                // 分享文案
                shareText: "御凤楼-全网最真实寻欢信息分享论坛，全国千万网友验证分享！",

                inviteUid: "",
                currentUserId: null,

                // ================== 防屏蔽过期（模板里有引用：保留字段） ==================
                antiBlockExpiredAt: 0, // 毫秒时间戳；后端不返回就保持 0
                nowTs: Date.now(),
                timerId: null,

                // ================== 模态框 ==================
                copyModal: {
                    visible: false,
                    text: "复制成功！",
                },
                withdrawModal: {
                    visible: false,
                    loading: false,
                },

                // ================== 并发锁 ==================
                loadingPromo: false,
                loadingStats: false,
                posterLoading: false,
            };
        },

        computed: {
            // 兼容你原本的过期逻辑：后端没给 antiBlockExpiredAt 就永远不触发过期
            isAntiBlockExpired() {
                return (
                    !!this.antiBlockLink &&
                    !!this.antiBlockExpiredAt &&
                    this.nowTs >= this.antiBlockExpiredAt
                );
            },

            wxqqBtnText() {
                if (this.genLoading) return "生成中...";
                if (!this.antiBlockLink) return "点击生成专属防屏蔽链接";
                if (this.isAntiBlockExpired) return "已过期 / 重新生成";
                return "已生成 / 点击复制";
            },

            expireCountdownText() {
                if (!this.antiBlockExpiredAt) return "";
                const left = Math.max(0, this.antiBlockExpiredAt - this.nowTs);
                const s = Math.floor(left / 1000);
                const mm = String(Math.floor(s / 60)).padStart(2, "0");
                const ss = String(s % 60).padStart(2, "0");
                return `${mm}:${ss}`;
            },
        },

        async mounted() {
            // mounted 兜底：token 失效就回登录
            const token = localStorage.getItem("token");
            if (!token) {
                this.$router.replace("/login");
                return;
            }

            // 更稳的 userId 获取（对齐 PC）
            this.currentUserId = this.resolveUserIdSafe();

            // 页面打开必须展示推广链接：立即拉 promoInfo
            await this.loadPromoInfo();

            // 再拉统计（不影响 promoLink 展示）
            await this.loadStatsInfo();

            // 倒计时刷新（你模板保留了倒计时区域，保持 nowTs 更新就不会出错）
            this.timerId = setInterval(() => {
                this.nowTs = Date.now();
            }, 1000);
        },

        beforeUnmount() {
            if (this.timerId) {
                clearInterval(this.timerId);
                this.timerId = null;
            }
        },

        methods: {
            // ================== 工具：金额分转元（对齐 PC） ==================
            centToYuan(cent) {
                const v = Number(cent);
                if (!Number.isFinite(v)) return "0.00";
                return (v / 100).toFixed(2);
            },

            // ================== 工具：更稳的 userId 获取（对齐 PC） ==================
            resolveUserIdSafe() {
                // 1) Vuex 你 mobile 未引入，这里不依赖
                // 2) localStorage 常见存法
                const tryKeys = ["user", "userinfo", "userInfo", "USER", "User"];
                for (const k of tryKeys) {
                    try {
                        const raw = localStorage.getItem(k);
                        if (!raw) continue;
                        const obj = JSON.parse(raw);
                        if (obj && obj.id) return obj.id;
                        if (obj && obj.data && obj.data.id) return obj.data.id;
                    } catch (e) {
                        // ignore
                    }
                }
                // 3) 拿不到返回 null，后端按 token 兜底也能跑
                return null;
            },

            // ================== 短链缓存（只给海报/业务用，不回显） ==================
            getShortLinkCacheKey() {
                return `promo_short_link_${this.currentUserId || "unknown"}`;
            },
            loadShortLinkFromCache() {
                try {
                    const key = this.getShortLinkCacheKey();
                    return localStorage.getItem(key) || "";
                } catch (e) {
                    return "";
                }
            },
            saveShortLinkToCache(shortLink) {
                if (!shortLink) return;
                try {
                    const key = this.getShortLinkCacheKey();
                    localStorage.setItem(key, shortLink);
                } catch (e) {
                    // ignore
                }
            },

            // ================== 页面打开：加载推广信息（必须展示 promoLink） ==================
            async loadPromoInfo() {
                if (this.loadingPromo) return;
                this.loadingPromo = true;

                try {
                    const params = this.currentUserId ? { userId: this.currentUserId } : null;
                    const res = await http.get("/platform/promo/myInfo", params);
                    const json = res.data;

                    if (!json || json.status !== 1) {
                        this.openCopyModal((json && json.msg) || "获取推广信息失败");
                        return;
                    }

                    const d = json.data || {};
                    this.promoLink = d.uidLink || "";
                    this.inviteUid = d.inviteUid || "";

                    // 页面展示短链必须用户手动生成，所以这里清空
                    this.antiBlockLink = "";
                    this.antiBlockExpiredAt = 0;

                    // 业务缓存短链：允许恢复（不影响页面回显规则）
                    this.antiBlockLinkCache = this.loadShortLinkFromCache();
                    if (!this.antiBlockLinkCache && d.shortLink) {
                        this.antiBlockLinkCache = d.shortLink;
                        this.saveShortLinkToCache(d.shortLink);
                    }
                } catch (e) {
                    console.error(e);
                    this.openCopyModal("获取推广信息失败，请稍后重试");
                } finally {
                    this.loadingPromo = false;
                }
            },

            // ================== 页面打开：加载统计（不影响主功能） ==================
            async loadStatsInfo() {
                if (this.loadingStats) return;
                this.loadingStats = true;

                try {
                    const params = this.currentUserId ? { userId: this.currentUserId } : null;
                    const res = await http.get("/platform/promo/stats", params);
                    const json = res.data;

                    if (!json || json.status !== 1) {
                        console.warn("[PromoStats] failed:", json);
                        return;
                    }

                    const d = json.data || {};
                    this.todayIncome = this.centToYuan(d.todayIncomeCent);
                    this.yesterdayIncome = this.centToYuan(d.yesterdayIncomeCent);
                    this.totalIncome = this.centToYuan(d.totalCommissionCent);
                    this.myCustomers = Number(d.myCustomers) || 0;
                } catch (e) {
                    console.error("[PromoStats] error:", e);
                } finally {
                    this.loadingStats = false;
                }
            },

            // ================== 跳转（你模板调用的全量方法） ==================
            goMyCustomers() {
                this.$router.push({ path: "/MyCustomers" });
            },
            goPromotionRules() {
                this.$router.push({ path: "/PromotionRules" });
            },
            goPromotionDetails() {
                this.$router.push({ path: "/PromotionDetails" });
            },

            // ✅ 海报：优先用缓存短链（不回显），没有再用页面短链，再用 promoLink（对齐 PC 的体验）
            async goPromotionPoster() {
                if (this.posterLoading) return;

                const token = localStorage.getItem("token");
                if (!token) {
                    this.$router.replace("/login");
                    return;
                }

                if (!this.currentUserId) this.currentUserId = this.resolveUserIdSafe();

                this.posterLoading = true;
                try {
                    let link = "";

                    // 1) 页面已生成短链优先
                    if (this.antiBlockLink) link = this.antiBlockLink;

                    // 2) 业务缓存短链
                    if (!link) {
                        if (!this.antiBlockLinkCache) {
                            this.antiBlockLinkCache = this.loadShortLinkFromCache();
                        }
                        link = this.antiBlockLinkCache || "";
                    }

                    // 3) 都没有则用 promoLink
                    if (!link) link = this.promoLink || "";

                    this.$router.push({
                        path: "/PromotionPoster",
                        query: { link },
                    });
                } finally {
                    this.posterLoading = false;
                }
            },

            // ================== 提现模态框（你原逻辑） ==================
            openWithdrawModal() {
                this.withdrawModal.visible = true;
            },
            closeWithdrawModal() {
                if (this.withdrawModal.loading) return;
                this.withdrawModal.visible = false;
            },
            async confirmWithdraw() {
                if (this.withdrawModal.loading) return;

                this.withdrawModal.loading = true;
                try {
                    this.withdrawModal.visible = false;
                    this.$router.push({ path: "/WalletWithdrawal" });
                } catch (e) {
                    console.error(e);
                    this.openCopyModal("操作失败，请稍后重试");
                } finally {
                    this.withdrawModal.loading = false;
                }
            },

            // ================== 复制模态框 ==================
            openCopyModal(text) {
                this.copyModal.text = text || "复制成功！";
                this.copyModal.visible = true;
            },
            closeCopyModal() {
                this.copyModal.visible = false;
            },

            // ================== 推广链接：点击复制（只复制 promoLink） ==================
            async copyPromoLinkAndModal() {
                if (!this.promoLink) {
                    this.openCopyModal("推广链接为空，请稍后重试");
                    return;
                }
                const ok = await this.copyText(this.promoLink);
                this.openCopyModal(ok ? "推广链接已复制！" : "复制失败，请手动复制");
            },

            // ================== 防屏蔽：复制内容（短链 + 文案） ==================
            getAntiBlockCopyContent() {
                return `${this.antiBlockLink}\n【${this.shareText}】`;
            },

            // 按钮点击：未生成/过期 => 生成；已生成 => 复制（与你 mobile 模板保持一致）
            async onWxqqBtnClick() {
                if (this.genLoading) return;

                if (!this.antiBlockLink || this.isAntiBlockExpired) {
                    await this.genAntiBlockLink();
                    return;
                }
                await this.copyAntiBlockAndModal();
            },

            // 链接/文案点击：复制（短链+文案）
            async copyAntiBlockAndModal() {
                if (!this.antiBlockLink) {
                    this.openCopyModal("请先生成防屏蔽链接");
                    return;
                }
                if (this.isAntiBlockExpired) {
                    this.openCopyModal("链接已过期，请重新生成");
                    return;
                }

                const ok = await this.copyText(this.getAntiBlockCopyContent());
                this.openCopyModal(ok ? "复制成功！" : "复制失败，请手动复制");
            },

            // ================== 生成防屏蔽链接（对齐 PC：/newShort） ==================
            async genAntiBlockLink() {
                if (this.genLoading) return;

                if (!this.currentUserId) this.currentUserId = this.resolveUserIdSafe();

                this.genLoading = true;
                try {
                    const url = this.currentUserId
                        ? `/platform/promo/newShort?userId=${this.currentUserId}`
                        : `/platform/promo/newShort`;

                    const res = await http.post(url);
                    const json = res.data;

                    if (!json || json.status !== 1) {
                        this.openCopyModal((json && json.msg) || "生成失败");
                        return;
                    }

                    const d = json.data || {};

                    // 页面展示：只展示新生成短链
                    this.antiBlockLink = d.shortLink || "";

                    // 过期时间：后端若返回 expireAt/expiredAt 等字段，你按实际字段名接上即可
                    // 示例（你后端字段不确定，我不硬写死）：this.antiBlockExpiredAt = Number(d.expireAt) || 0;
                    this.antiBlockExpiredAt = 0;

                    // 同步缓存（海报入口也能直接用）
                    this.antiBlockLinkCache = this.antiBlockLink || "";
                    this.saveShortLinkToCache(this.antiBlockLinkCache);

                    // 同步可能回传的 uidLink / inviteUid
                    if (d.uidLink) this.promoLink = d.uidLink;
                    if (d.inviteUid) this.inviteUid = d.inviteUid;

                    // PC 端生成会提示；你若想完全不弹，把这一行删掉
                    this.openCopyModal("防屏蔽链接生成成功！");
                } catch (e) {
                    console.error(e);
                    this.openCopyModal("生成失败，请稍后重试");
                } finally {
                    this.genLoading = false;
                }
            },

            // ================== 通用复制：clipboard 优先，降级 execCommand ==================
            async copyText(text) {
                try {
                    if (navigator.clipboard && window.isSecureContext) {
                        await navigator.clipboard.writeText(text);
                        return true;
                    }
                } catch (e) {
                    // ignore
                }

                try {
                    const ta = document.createElement("textarea");
                    ta.value = text;
                    ta.setAttribute("readonly", "");
                    ta.style.position = "fixed";
                    ta.style.left = "-9999px";
                    ta.style.top = "0";
                    document.body.appendChild(ta);
                    ta.select();
                    const ok = document.execCommand("copy");
                    document.body.removeChild(ta);
                    return ok;
                } catch (e) {
                    return false;
                }
            },
        },
    };
</script>

<style scoped>
    .fa {
        margin-right: 6px;
    }

    .zhu {
        margin-top: 80px;
    }

    /* 顶部模块 */
    .promo-top {
        background: #fff;
        border-top: 1px solid #dcdcdc;
        border-bottom: 1px solid #dcdcdc;
    }

    .promo-title {
        padding: 12px;
        font-weight: 700;
        border-bottom: 1px solid #e6e6e6;
    }

    .promo-main {
        text-align: center;
        padding: 14px 12px;
        border-bottom: 1px solid #e6e6e6;
    }

    .promo-money {
        font-size: 18px;
        font-weight: 600;
    }

    .promo-text {
        font-size: 12px;
        color: #666;
    }

    .promo-stat {
        display: flex;
    }

    .stat-item {
        flex: 1;
        text-align: center;
        padding: 10px 0;
    }

    .stat-money {
        font-size: 14px;
        font-weight: 700;
        color: #111;
    }

    .stat-label {
        font-size: 14px;
        color: #666;
    }

    .stat-line {
        width: 1px;
        background: #dcdcdc;
    }

    /* 内容区 */
    .content-area {
        background: #efefef;
    }

    .card-item {
        background: #fff;
        border: 1px solid #dcdcdc;
        border-radius: 2px;
        padding: 14px 12px;
        margin-bottom: 10px;
    }

    .no-gap-after {
        margin-bottom: 0 !important;
        border-bottom: 0;
    }

    .arrow {
        font-size: 22px;
        color: #bfbfbf;
    }

    .link-box {
        border: 1px solid #dcdcdc;
        padding: 10px;
        font-size: 14px;
        word-break: break-all;
    }

    .must {
        font-size: 12px;
        color: #00c26f;
        font-weight: 700;
    }

    .clickable {
        cursor: pointer;
    }

    /* ================= 微信 / QQ 专用 ================= */

    .wxqq-card {
        margin-top: 6px;
        padding: 0;
    }

    .wxqq-header {
        display: flex;
        align-items: center;
        padding: 10px 12px;
        border-bottom: 1px solid #e6e6e6;
        justify-content: flex-start;
    }

    .wxqq-title {
        font-size: 14px;
        font-weight: 700;
    }

    .wxqq-btn {
        padding: 4px 10px;
        font-size: 12px;
        color: #333;
        background: #00c26f;
        border: 1px solid #d0d0d0;
        border-radius: 4px;
        margin-left: 8px;
    }

    .wxqq-btn:active {
        background: #ededed;
    }

    .wxqq-body {
        padding: 10px 12px 12px;
    }

    .wxqq-link {
        padding: 6px 8px;
        font-size: 15px;
        border-bottom: 1px solid #e6e6e6;
        word-break: break-all;
    }

    .wxqq-desc {
        padding: 10px 12px;
        font-size: 15px;
        font-weight: 700;
        word-break: break-all;
    }

    .wxqq-expire {
        padding: 0 12px 10px;
        font-size: 12px;
        color: #666;
    }

    .wxqq-tip {
        padding: 0 12px 10px;
        font-size: 12px;
        color: #999;
    }

    /* ================= 新增：行图标布局（你原样保留） ================= */

    .row-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .row-left {
        display: flex;
        align-items: center;
        gap: 12px;
    }

    .row-ico {
        width: 22px;
        height: 22px;
        border: 1px solid #cfcfcf;
        border-radius: 3px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .row-ico .fa {
        margin-right: 0;
        font-size: 14px;
        color: #ff4d4f;
    }

    .row-text {
        font-size: 16px;
        color: #111;
    }

    .row-right {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    /* ✅ 新增：可点击复制的统一手感 */
    .clickable-text {
        cursor: pointer;
        user-select: text;
    }
    .clickable-text:active {
        opacity: 0.75;
    }

    .promo-link-tip {
        margin-top: 6px;
        font-size: 12px;
        color: #999;
    }

    /* ================= 模态框（你原样保留） ================= */

    .modal-mask {
        position: fixed;
        inset: 0;
        z-index: 9999;
        background: rgba(0, 0, 0, 0.55);
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 18px;
    }

    .modal-card {
        width: 100%;
        max-width: 520px;
        background: #fff;
        border-radius: 6px;
        overflow: hidden;
        box-shadow: 0 18px 60px rgba(0, 0, 0, 0.25);
    }

    .modal-title {
        text-align: center;
        font-size: 18px;
        font-weight: 700;
        padding: 20px 18px 10px;
        color: #111827;
    }

    .modal-desc {
        text-align: center;
        font-size: 14px;
        color: #6b7280;
        padding: 0 18px 18px;
    }

    .modal-actions {
        display: flex;
        border-top: 1px solid #eef0f5;
    }

    .modal-btn {
        flex: 1;
        height: 52px;
        border: 0;
        background: #fff;
        font-size: 16px;
        cursor: pointer;
    }

    .modal-btn:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }

    .modal-btn.cancel {
        color: #6b7280;
        border-right: 1px solid #eef0f5;
    }

    .modal-btn.ok {
        color: #e53935;
        font-weight: 700;
    }

    .modal-btn:active:not(:disabled) {
        background: #f6f7fb;
    }
</style>
